import { useState } from "react";

export default class EventoModel {
  public codAudienciaPublica: any;
  public setCodAudienciaPublica: any;
  public nuAudienciaPublica: any;
  public setNuAudienciaPublica: any;
  public nuAno: any;
  public setNuAno: any;
  public codSituacaoAudiencia: any;
  public setCodSituacaoAudiencia: any;
  public dtInicioValidade: any;
  public setDtInicioValidade: any;
  public dtFimValidade: any;
  public setDtFimValidade: any;

  public dtInicioValidadeHistorico: any;
  public setDtInicioValidadeHistorico: any;
  public dtFimValidadeHistorico: any;
  public setDtFimValidadeHistorico: any;

  public dsResumo: any;
  public setDsResumo: any;
  public dsTexto: any;
  public setDsTexto: any;
  public dsSuperintendencia: any;
  public setDsSuperintendencia: any;
  public cdTpEvento: any;
  public setCdTpEvento: any;
  public dsLinkVideo: any;
  public setDsLinkVideo: any;
  public dsProcedimento: any;
  public setDsProcedimento: any;
  public dsProximoPasso: any;
  public setDsProximoPasso: any;
  public stEventoRestrito: any;
  public setStEventoRestrito: any;
  public stAgendaRegulatoria: any;
  public setStAgendaRegulatoria: any;
  public dtPublicacaoDou: any;
  public setDtPublicacaoDou: any;
  public stContrato: any;
  public setStContrato: any;
  public cdTpEventoNavigation: any;
  public setCdTpEventoNavigation: any;
  public codSituacaoAudienciaNavigation: any;
  public setCodSituacaoAudienciaNavigation: any;
  public degravacao: any;
  public setDegravacao: any;
  public normaDefinitiva: any;
  public setNormaDefinitiva: any;
  public propostaNorma: any;
  public setPropostaNorma: any;
  public dispositivoList: any;
  public setDispositivoList: any;
  public qtdContribuicoesPorContribuinte: any;
  public setQtdContribuicoesPorContribuinte: any;
  public dsLinkDivulgacaoEvento: any;
  public setdsLinkDivulgacaoEvento: any;
  public dsLinkNormaDefinitiva: any;
  public setDsLinkNormaDefinitiva: any;
  public codPropostaNorma: any;
  public setCodPropostaNorma: any;

  constructor() {
    [this.codAudienciaPublica, this.setCodAudienciaPublica] = useState("");
    [this.nuAudienciaPublica, this.setNuAudienciaPublica] = useState("");
    [this.nuAno, this.setNuAno] = useState("");
    [this.codSituacaoAudiencia, this.setCodSituacaoAudiencia] = useState("");
    [this.dtInicioValidade, this.setDtInicioValidade] = useState("");
    [this.dtFimValidade, this.setDtFimValidade] = useState("");

    [this.dtInicioValidadeHistorico, this.setDtInicioValidadeHistorico] =
      useState("");
    [this.dtFimValidadeHistorico, this.setDtFimValidadeHistorico] =
      useState("");

    [this.dsResumo, this.setDsResumo] = useState("");
    [this.dsTexto, this.setDsTexto] = useState("");
    [this.dsSuperintendencia, this.setDsSuperintendencia] = useState("");
    [this.cdTpEvento, this.setCdTpEvento] = useState("");
    [this.dsLinkVideo, this.setDsLinkVideo] = useState("");
    [this.dsProcedimento, this.setDsProcedimento] = useState("");
    [this.dsProximoPasso, this.setDsProximoPasso] = useState("");
    [this.stEventoRestrito, this.setStEventoRestrito] = useState("");
    [this.stAgendaRegulatoria, this.setStAgendaRegulatoria] = useState("");
    [this.dtPublicacaoDou, this.setDtPublicacaoDou] = useState("");
    [this.stContrato, this.setStContrato] = useState("");
    [this.cdTpEventoNavigation, this.setCdTpEventoNavigation] = useState("");
    [
      this.codSituacaoAudienciaNavigation,
      this.setCodSituacaoAudienciaNavigation,
    ] = useState("");
    [this.degravacao, this.setDegravacao] = useState([]);
    [this.normaDefinitiva, this.setNormaDefinitiva] = useState([]);
    [this.propostaNorma, this.setPropostaNorma] = useState("");
    [this.dispositivoList, this.setDispositivoList] = useState([]);
    [
      this.qtdContribuicoesPorContribuinte,
      this.setQtdContribuicoesPorContribuinte,
    ] = useState("");
    [this.dsLinkDivulgacaoEvento, this.setdsLinkDivulgacaoEvento] =
      useState("");
    [this.dsLinkNormaDefinitiva, this.setDsLinkNormaDefinitiva] = useState("");
    [this.codPropostaNorma, this.setCodPropostaNorma] = useState("");
  }

  public sync(entity: any) {
    this.setCodAudienciaPublica(entity.codAudienciaPublica);
    this.setNuAudienciaPublica(entity.nuAudienciaPublica);
    this.setNuAno(entity.nuAno);
    this.setCodSituacaoAudiencia(entity.codSituacaoAudiencia);
    this.setDtInicioValidade(entity.dtInicioValidade);
    this.setDtFimValidade(entity.dtFimValidade);

    this.setDtInicioValidadeHistorico(entity.dtInicioValidadeHistorico);
    this.setDtFimValidadeHistorico(entity.dtFimValidadeHistorico);

    this.setDsResumo(entity.dsResumo);
    this.setDsTexto(entity.dsTexto);
    this.setDsSuperintendencia(entity.dsSuperintendencia);
    this.setCdTpEvento(entity.cdTpEvento);
    this.setDsLinkVideo(entity.dsLinkVideo);
    this.setDsProcedimento(entity.dsProcedimento);
    this.setDsProximoPasso(entity.dsProximoPasso);
    this.setStEventoRestrito(entity.stEventoRestrito);
    this.setStAgendaRegulatoria(entity.stAgendaRegulatoria);
    this.setDtPublicacaoDou(entity.dtPublicacaoDou);
    this.setStContrato(entity.stContrato);
    this.setCdTpEventoNavigation(entity.cdTpEventoNavigation);
    this.setCodSituacaoAudienciaNavigation(
      entity.codSituacaoAudienciaNavigation
    );
    this.setDegravacao(entity.degravacao);
    this.setNormaDefinitiva(entity.normaDefinitiva);
    this.setPropostaNorma(entity.propostaNorma);
    this.setQtdContribuicoesPorContribuinte(
      entity.qtdContribuicoesPorContribuinte
    );

    this.extrairDispositivo(entity);
    this.setdsLinkDivulgacaoEvento(entity.dsLinkDivulgacaoEvento);
    this.setDsLinkNormaDefinitiva(entity.dsLinkNormaDefinitiva)

  }

  private extrairDispositivo(entity: any) {
    if (!entity.propostaNorma || entity.propostaNorma.length === 0) {
      return;
    }
    const list = [];
    for (const pm of entity.propostaNorma) {
      if (!!pm.dispositivo && pm.dispositivo.length > 0) {
        list.push(...pm.dispositivo);
      }
    }
    this.setDispositivoList(list);
  }
}
